import Styles from './styles.module.css';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { ImCross } from "react-icons/im";
import { IoImageOutline } from "react-icons/io5";
import ErrorMessage from '../../../package/error/index';
import DefaultInput1 from '../../../package/1-input/index';
import { v4 as uuid } from 'uuid';
import DefaultImage from './../../../../image/default/wait.png';
import { doc, getFirestore, updateDoc } from 'firebase/firestore';
import { getStorage, ref, uploadBytes } from 'firebase/storage';
import { summaryData } from 'src/type';

type RecruitSummary = {
  documentId: string;
  setChangeData: React.Dispatch<React.SetStateAction<boolean>>;
  summary: summaryData;
  setSummary: React.Dispatch<React.SetStateAction<summaryData>>;
  // 選択直後（アップロード前）の画像をプレビューへ即時反映するための連携
  onPreviewImage?: (id: string, url: string) => void;
};

const RecruitSummary: React.FC<RecruitSummary> = ({ documentId, setChangeData, summary, setSummary, onPreviewImage }) => {

  type ImageItem = {
    id: string;
    file?: File;
    url: string;
  };

  useEffect(() => {
    if (!summary.images) return;

    const hydrated: ImageItem[] = summary.images.map((id: string) => ({
      id,
      url: `https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/styles%2Fresize_images%2F${id}_500x500?alt=media`,
      // https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/styles%2Fresize_images%2Fq9ZZfoPunhW0NmIh5Qe6UzvRqS93_500x500?alt=media
    }));

    setImages(hydrated);
  }, []);

  const [ images, setImages ] = useState<ImageItem[]>([]);
  const [ errorMessage, setErrorMessage ] = useState('');
  const [ banner, setBanner ] = useState(false);

  const makeImageItem = (file: File): ImageItem => {
    const item = { id: uuid(), file, url: URL.createObjectURL(file) };
    onPreviewImage?.(item.id, item.url);
    return item;
  };

  // 空きスロットから追加（末尾に追加）
  const addImage = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;

    const item = makeImageItem(file);

    setImages(prev => [...prev, item]);
    setSummary(prev => ({ ...prev, images: [...prev.images, item.id] }));
    setChangeData(true);
  };

  // 既存スロットの差し替え
  const replaceImage = (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;

    const item = makeImageItem(file);

    setImages(prev => prev.map((img, idx) => (idx === index ? item : img)));
    setSummary(prev => ({
      ...prev,
      images: prev.images.map((id: string, idx: number) => (idx === index ? item.id : id)),
    }));
    setChangeData(true);
  };

  const removeImage = (index: number) => {
    setImages(prev => prev.filter((_, idx) => idx !== index));
    setSummary(prev => ({
      ...prev,
      images: prev.images.filter((_: string, idx: number) => idx !== index),
    }));
    setChangeData(true);
  };

  function validateCompanyData(data: summaryData): string | null {
    if (!data.name) return 'サロン名を入力してください。';
    if (!data.title) return '求人タイトルを入力してください。';
    if (data.images.length === 0) return '写真は1枚以上添付してください。';
    return null;
  }

  function check() {
    setErrorMessage('');
    window.scrollTo(0, 0);

    const error = validateCompanyData(summary);

    if (error) {
      setErrorMessage(error);
      return;
    }

    save(true);
  }

  const [ uploading, setUploading ] = useState(false);

  async function save(isCompleted: boolean) {
    setUploading(true);

    const db = getFirestore();
    const storage = getStorage();

    let ok = false;

    try {
      const uploadedIds: string[] = [];

      // ① 画像アップロード
      for (const img of images) {
        if (img.file) {
          const storageRef = ref(storage, `/styles/${img.id}`);
          await uploadBytes(storageRef, img.file);
        }

        uploadedIds.push(img.id);
      }

      // ② Firestore更新
      const dataToSend = {
        ...summary,
        images: uploadedIds,
        isCompleted,
        time: new Date(),
      };

      await updateDoc(doc(db, "recruits", documentId), {
        summary: dataToSend,
      });

      setChangeData(false);
      ok = true;
    } catch (error) {
      console.error("🔥 保存に失敗:", error);
      setErrorMessage('保存に失敗しました。時間をおいてもう一度お試しください。');
    } finally {
      setUploading(false);
      // 保存できたときだけ「保存しました」を出す(失敗時に出ていたバグの修正)。
      if (ok) {
        setBanner(true);
        setTimeout(() => {
          setBanner(false);
        }, 1500);
      }
    }
  }

  return (
    <>
      {errorMessage && <ErrorMessage message={errorMessage} />}

      {/* ================= header ================= */}
      <div className={Styles.title_edit}>
        <h4>企業情報の編集</h4>

        <div className={Styles.title_edit_btn}>
          <button className={Styles.save_box_now} onClick={() => save(false)}>
            一時保存
          </button>

          <button className={Styles.save_box_save} onClick={() => check()}>
            保存
          </button>
        </div>
      </div>

      {/* ================= inputs ================= */}
      <div className={Styles.test_box}>
        <DefaultInput1
          error={false}
          title={"サロン名 ※"}
          length={20}
          place={"memorii美容院、memorii美容院 横浜店"}
          value={summary.name}
          setValue={(val: string) => {
            setSummary((prev) => ({ ...prev, name: val }));
            setChangeData(true);
          }}
          desc={""}
          hint={{ title: "", desc: "" }}
        />

        <DefaultInput1
          error={false}
          title={"求人タイトル ※"}
          length={30}
          place={
            "<メディア掲載実績多数>　急成長中のトレンドサロンで美容師になりませんか？"
          }
          value={summary.title}
          setValue={(val: string) => {
            setSummary((prev) => ({ ...prev, title: val }));
            setChangeData(true);
          }}
          desc={""}
          hint={{ title: "", desc: "" }}
        />
      </div>

      {/* ================= images ================= */}
      <div className={Styles.test_box}>
        <p className={Styles.store_input_photo_title}>
          店舗写真（{images.length}枚/5枚中） ※
        </p>

        <div className={Styles.photoGrid}>
          {Array.from({ length: 5 }).map((_, i) => {
            const img = images[i];

            if (img) {
              return (
                <div key={img.id} className={Styles.photoSlot}>
                  <label className={`${Styles.photoBox} ${Styles.photoBox_filled}`}>
                    <img
                      className={Styles.photoPreview}
                      src={img.url}
                      alt=""
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = DefaultImage;
                      }}
                    />
                    <input
                      type="file"
                      accept="image/*"
                      className={Styles.hiddenInput}
                      onChange={(e) => replaceImage(i, e)}
                    />
                  </label>
                  {i === 0 && <span className={Styles.photoMain}>メイン</span>}
                  <button
                    type="button"
                    className={Styles.photoRemove}
                    aria-label="削除"
                    onClick={() => removeImage(i)}
                  >
                    <ImCross />
                  </button>
                </div>
              );
            }

            return (
              <div key={`empty-${i}`} className={Styles.photoSlot}>
                <label className={Styles.photoBox}>
                  <span className={Styles.photoPlaceholder}>
                    <IoImageOutline className={Styles.photoPlaceholderIcon} />
                    写真を追加
                  </span>
                  <input
                    type="file"
                    accept="image/*"
                    className={Styles.hiddenInput}
                    onChange={addImage}
                  />
                </label>
              </div>
            );
          })}
        </div>
      </div>

      {/* ================= banner ================= */}
      {banner && (
        <div className={Styles.banner}>
          保存しました。
        </div>
      )}

      {uploading && (
        <div className={Styles.lockOverlay}>
          <div className={Styles.spinner} />
          <p>アップロード中...</p>
        </div>
      )}
    </>
  );
}

export default RecruitSummary;

